// extracted by mini-css-extract-plugin
export default {"information":"InformationItem_information__aj4o7","informationIcon":"InformationItem_informationIcon__A7XH5","description":"InformationItem_description__zxFmI"};